import { NoImage } from "@assets/constant/index.constant";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { isNullCheck } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";

const ColumnList = () => {
  const { handleAction } = useHandleAction({});
  const { clearSelection } = useSelectionStore();
  return [
    {
      name: "ID",

      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row?.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Image",

      cell: (row: any) => (
        <div className="flex items-center gap-3">
          <ZoomImage>
            <img
              src={row.image || NoImage}
              alt="featured"
              onError={(e: any) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = NoImage;
              }}
              className="w-12 h-12 object-cover rounded"
            />
          </ZoomImage>
        </div>
      ),
      sortable: false,
    },

    {
      name: "Full Name",

      cell: (row: any) => (
        <div className="text-lg capitalize font-semibold text-gray-800">
          <Tooltip description={row.user.full_name}>
            <span className="max-w-[120px] cursor-pointer capitalize block truncate">
              {isNullCheck(row.user.full_name) as string}
            </span>
          </Tooltip>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3  cursor-pointer">
          <button
            className=" cursor-pointer text-[#1DA077]"
            onClick={() => handleAction({ type: "modal-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className=" cursor-pointer text-[#C33241]"
            onClick={() => {
              clearSelection();
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              });
            }}
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

export { ColumnList };
